<script>
  import conciliacaoProjetoServico from '../servico';

  const ABAS = [
    { categoria: 'atrasado', titulo: 'Atrasados', ajuda: 'Contas a pagar em aberto com previsão (ou, sem previsão, vencimento) antes do primeiro dia útil depois da data de referência, dentro da janela configurada.' },
    { categoria: 'apagar', titulo: 'A pagar', ajuda: 'Contas a pagar com previsão ou, sem previsão, vencimento do primeiro dia útil depois da data de referência até o fim do horizonte.' },
    { categoria: 'bordero', titulo: 'Em borderô', ajuda: 'Títulos em borderô aberto, ainda sem baixa.' },
    { categoria: 'transferencia', titulo: 'Transferências', ajuda: 'Solicitações de transferência liberadas e lançamentos de transferência ainda não pagos.' },
    { categoria: '', titulo: 'Todos', ajuda: 'Todos os compromissos que entram no cálculo do livre para aplicar.' },
  ];

  export default {
    props: {
      conta: { type: Object, required: true },
      categoriaInicial: { type: String, default: '' },
      dataReferencia: { type: String, default: '' },
      horizonte: { type: Number, default: 1 },
      ateData: { type: String, default: '' },
      limite: { type: String, default: '' },
    },
    data() {
      return {
        carregando: true,
        erro: '',
        itens: [],
        categoria: this.categoriaInicial,
        abas: ABAS,
      };
    },
    computed: {
      abaAtiva() { return this.abas.filter(a => a.categoria === this.categoria)[0] || this.abas[4]; },
      visiveis() { return this.categoria ? this.itens.filter(i => i.categoria === this.categoria) : this.itens; },
      total() { return this.visiveis.reduce((t, i) => t + (i.valor || 0), 0); },
    },
    mounted() {
      conciliacaoProjetoServico.compromissosTesouraria(this.conta.idContaCript, this.dataReferencia, this.horizonte, this.ateData)
        .then(dados => { this.itens = dados || []; this.carregando = false; })
        .catch(res => {
          this.carregando = false;
          this.erro = res && res.body && res.body.message ? res.body.message : 'Não foi possível carregar os lançamentos.';
        });
    },
    methods: {
      qtde(categoria) { return categoria ? this.itens.filter(i => i.categoria === categoria).length : this.itens.length; },
      moeda(v) {
        const n = v || 0;
        return (n < -0.004 ? '−R$ ' : 'R$ ') + Math.abs(n).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      },
      origemTexto(o) {
        switch (o) {
          case 'bordero': return 'borderô';
          case 'previsto': return 'previsto';
          case 'atrasado': return 'atrasado';
          case 'transferencia': return 'transferência';
          default: return 'vencendo';
        }
      },
      origemCls(o) {
        switch (o) {
          case 'bordero': return 'chip-roxo';
          case 'previsto': return 'chip-azul';
          case 'atrasado': return 'chip-vermelho';
          case 'transferencia': return 'chip-verde';
          default: return 'chip-ambar';
        }
      },
      exportar() {
        const num = v => (+(v || 0)).toFixed(2).replace('.', ',');
        const txt = v => '"' + ('' + (v === null || v === undefined ? '' : v)).replace(/"/g, '""') + '"';
        const linhas = [['Fornecedor', 'Valor', 'Vencimento', 'Previsão', 'Borderô', 'Forma', 'Origem', 'Coluna'].map(txt).join(';')];
        this.visiveis.forEach(i => {
          linhas.push([txt(i.fornecedor), num(i.valor), txt(i.vencimento), txt(i.previsao), txt(i.numeroBordero), txt(i.forma),
            txt(this.origemTexto(i.origem)), txt((this.abas.filter(a => a.categoria === i.categoria)[0] || {}).titulo)].join(';'));
        });
        const blob = new Blob(['﻿' + linhas.join('\r\n')], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'compromissos-' + (this.conta.numeroConta || 'conta') + '.csv';
        link.click();
        URL.revokeObjectURL(url);
      },
    },
  };
</script>

<template>
  <div class="cp-ov">
    <div class="cp-modal">
      <div class="cp-head">
        <h4>Compromissos da conta {{ conta.nomeConta }}</h4>
        <small>{{ conta.nomeBanco }} · Ag {{ conta.numeroAgencia }} · C/C {{ conta.numeroConta }} · horizonte até {{ limite }}</small>
      </div>

      <div class="cp-barra">
        <button v-for="a in abas" :key="a.categoria || 'todos'" type="button" class="cp-aba" :class="{ ativo: categoria === a.categoria }"
                @click="categoria = a.categoria">
          {{ a.titulo }} <span class="cp-n">{{ qtde(a.categoria) }}</span>
        </button>
      </div>
      <div class="cp-ajuda">{{ abaAtiva.ajuda }}</div>

      <div class="cp-corpo">
        <div v-if="carregando" class="cp-msg"><i class="fa fa-spinner fa-pulse fa-2x"></i></div>
        <div v-else-if="erro" class="cp-msg cp-erro"><i class="fa fa-exclamation-triangle"></i> {{ erro }}</div>
        <div v-else-if="!visiveis.length" class="cp-msg"><i class="fa fa-check"></i> Nenhum lançamento nesta coluna.</div>
        <table v-else class="cp-tab">
          <thead>
            <tr>
              <th>Fornecedor / destino</th>
              <th class="r">Valor</th>
              <th>Vencimento</th>
              <th>Previsão</th>
              <th>Borderô</th>
              <th>Forma</th>
              <th>Origem</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(i, k) in visiveis" :key="'c' + k">
              <td class="forn" :title="i.fornecedor">{{ i.fornecedor }}</td>
              <td class="r mono">{{ moeda(i.valor) }}</td>
              <td class="mono">{{ i.vencimento || '—' }}</td>
              <td class="mono">{{ i.previsao || '—' }}</td>
              <td>
                <template v-if="i.numeroBordero">
                  <span class="mono">{{ i.numeroBordero }}</span>
                  <span class="chip" :class="i.arquivoGerado > 1 ? 'chip-verde' : 'chip-cinza'">{{ i.arquivoGerado > 1 ? 'arquivo enviado ' + i.arquivoGeradoTexto : 'aberto' }}</span>
                </template>
                <span v-else class="mudo">—</span>
              </td>
              <td>{{ i.forma || '—' }}</td>
              <td><span class="chip" :class="origemCls(i.origem)">{{ origemTexto(i.origem) }}</span></td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="cp-foot">
        <div class="cp-total">
          <span>{{ visiveis.length }} {{ visiveis.length === 1 ? 'lançamento' : 'lançamentos' }}</span>
          <b class="mono">{{ moeda(total) }}</b>
        </div>
        <div class="cp-acoes">
          <button type="button" class="btn btn-primary" :disabled="!visiveis.length" @click="exportar"><i class="fa fa-file-excel-o"></i> Exportar Excel</button>
          <button type="button" class="btn rd-sair" @click="$emit('fechar')"><i class="fa fa-times"></i> Fechar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .cp-ov { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(16,24,40,.55); z-index: 2100; display: flex; align-items: center; justify-content: center; }
  .cp-modal { width: 1100px; max-width: 96vw; height: 82vh; display: flex; flex-direction: column; background: #fff; border-radius: 8px; box-shadow: 0 16px 48px rgba(16,24,40,.35); overflow: hidden; }
  .cp-head { flex: 0 0 auto; padding: 14px 18px; border-bottom: 1px solid #eceef1; }
  .cp-head h4 { margin: 0; font-size: 16px; font-weight: 600; color: #1c2024; }
  .cp-head small { display: block; color: #8a939c; font-size: 12px; margin-top: 3px; font-family: 'IBM Plex Mono', Consolas, monospace; }
  .cp-barra { flex: 0 0 auto; display: flex; gap: 6px; padding: 10px 18px 0; border-bottom: 1px solid #eceef1; }
  .cp-aba { display: inline-flex; align-items: center; gap: 7px; padding: 8px 14px; border: 1px solid #dfe3e8; border-bottom: none; border-radius: 6px 6px 0 0; background: #f7f9fa; color: #5b6570; font-size: 13px; font-weight: 600; cursor: pointer; }
  .cp-aba:hover { background: #f2fbf8; }
  .cp-aba.ativo { background: #e8f5ef; border-color: #0f8a5f; color: #0a6d4d; }
  .cp-n { display: inline-block; min-width: 20px; padding: 0 6px; border-radius: 10px; background: #fff; border: 1px solid #dfe3e8; font-size: 11px; color: #5b6570; text-align: center; }
  .cp-ajuda { flex: 0 0 auto; padding: 6px 18px; font-size: 12px; color: #6b747e; background: #fbfcfd; border-bottom: 1px solid #eceef1; }
  .cp-corpo { flex: 1 1 auto; min-height: 0; overflow: auto; }
  .cp-msg { text-align: center; padding: 40px; color: #8a939c; }
  .cp-msg .fa-check { color: #1ab394; }
  .cp-erro { color: #a13c3c; }
  .cp-tab { width: 100%; border-collapse: collapse; }
  .cp-tab th { position: sticky; top: 0; z-index: 1; background: #f7f9fa; font-size: 10.5px; text-transform: uppercase; letter-spacing: .05em; color: #7b848e; font-weight: 600; text-align: left; padding: 8px 10px; border-bottom: 1px solid #dfe3e8; white-space: nowrap; }
  .cp-tab th.r, .cp-tab td.r { text-align: right; }
  .cp-tab td { font-size: 12.5px; color: #34495e; padding: 7px 10px; border-top: 1px solid #f0f1f3; white-space: nowrap; vertical-align: middle; }
  .cp-tab tbody tr:nth-child(even) > td { background: #fbfcfd; }
  .cp-tab tbody tr:hover > td { background: #eaf5ff; }
  .cp-tab td.forn { max-width: 380px; overflow: hidden; text-overflow: ellipsis; }
  .mono { font-family: 'IBM Plex Mono', Consolas, monospace; font-variant-numeric: tabular-nums; }
  .mudo { color: #b3b9c0; }
  .cp-foot { flex: 0 0 auto; display: flex; justify-content: space-between; align-items: center; padding: 12px 18px; border-top: 1px solid #dfe3e8; background: #f7f9fa; }
  .cp-total { display: flex; align-items: baseline; gap: 10px; font-size: 13px; color: #5b6570; }
  .cp-total b { font-size: 15px; color: #1c2024; }
  .cp-acoes { display: flex; gap: 8px; }
  .rd-sair { background: #fdf1f1; border: 1px solid #e4d7d7; color: #a13c3c; font-weight: 600; }
  .rd-sair:hover { background: #fbe7e7; border-color: #d9c2c2; color: #a13c3c; }
  .chip { display: inline-flex; align-items: center; font-size: 10.5px; font-weight: 600; border-radius: 10px; padding: 1px 8px; line-height: 16px; white-space: nowrap; border: 1px solid transparent; margin-left: 4px; }
  .chip-cinza { color: #5b6570; background: #f1f3f5; border-color: #dfe3e8; }
  .chip-vermelho { color: #a13c3c; background: #fdecec; border-color: #f5c6c6; }
  .chip-roxo { color: #5b3a9e; background: #f1ecfa; border-color: #d9cdf0; }
  .chip-ambar { color: #8a5a00; background: #fdf3e0; border-color: #f0d9a8; }
  .chip-azul { color: #2b5b8c; background: #e8f1fb; border-color: #c2d8ef; }
  .chip-verde { color: #0a6d4d; background: #e5f7f0; border-color: #b8e4d2; }
</style>



// WEBPACK FOOTER //
// FrontEnd/modulos/conciliacao-projeto/componentes/PosicaoTesourariaCompromissos.vue